import { Component, OnInit } from '@angular/core';
import { AccountsService } from '../accounts/accounts.service';
import { UsersService } from './users.service';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'users-component',
  template: require('./users.component.html'),
  styles: [require('./users.component.scss')]
})
export class UsersComponent implements OnInit {
  account: any;
  reverse: boolean= false;
  predicate: string = 'created_at';
  onlyActive: boolean= true;
  users: any[] = [];
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: UsersService, private router: Router) {
  }

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    if (!this.account) {
       this.router.navigate(['/accounts']);
    } else {
      this.service.getUsers(this.account.id).subscribe(users => {
        this.users = users;
        this.sortBy('it.created_at', 'created_at');
      });
    }
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function('it', `return (${getField} || '').toString().toLowerCase();`);
  }

  formatDate(date: any) {
    return moment(date).format('DD/MM/YYYY hh:mm A');
  }

  editUser(user: any) {
    UsersService.currentUser = user;
    this.router.navigate(['/edituser']);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/users.component.ts